import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GetStudyResponse } from '@core/types';
import { STUDY_QUERY_KEY } from '../../../core/hooks/useStudyInfo';
import deleteStudyTag from '../api/deleteStudyTag';

const MUTATION_KEY = ['study', 'removeTag'];

const useRemoveTag = (studyInstanceUid: string) => {
  const queryClient = useQueryClient();
  const { mutateAsync: removeTag, ...rest } = useMutation({
    mutationKey: [MUTATION_KEY, studyInstanceUid],
    mutationFn: (tagTitle: string) => deleteStudyTag({ studyInstanceUid, tagTitle }),
    onSuccess: (updated) => {
      queryClient.setQueryData<GetStudyResponse>(
        [STUDY_QUERY_KEY, studyInstanceUid],
        (existingStudy) => {
          if (existingStudy) {
            existingStudy.tags = updated.tags;
          }

          return existingStudy;
        },
      );
    },
  });

  return { removeTag, ...rest };
};

export default useRemoveTag;
